import { render, staticRenderFns } from "./CardType.vue?vue&type=template&id=4795fcd3&"
import script from "./CardType.vue?vue&type=script&lang=ts&"
export * from "./CardType.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports